/** @jsxImportSource @emotion/react */
import { FC } from 'react'
import { Link } from 'react-router-dom'
import Typography from '@mui/material/Typography'
import { cmsRoutes } from 'routes/cmsRoutes'
import { ReactComponent as Logo } from 'assets/icons/logo-grey.svg'
import * as classes from './styles'

const AuthHeader: FC = () => (
  <div css={classes.header}>
    <Link css={classes.link} to={cmsRoutes.SIGN_IN}>
      <Logo css={classes.logo} />
      <Typography css={classes.logoText} variant="h4">
        Booster CMS
      </Typography>
    </Link>
    <Typography
      css={classes.title}
      variant="body2"
      sx={{
        fontWeight: 400,
      }}
    >
      Building innovative study tools.
    </Typography>
  </div>
)

export default AuthHeader
